import { Route, Switch } from "react-router-dom";
import useCheckEvent from "../Hooks/useCheckEvent.js";
import NotFound from "../Pages/404/404.js";
import Action from "../Pages/Action/Action.js";
import Club from "../Pages/Club/Club.js";
import ConnectDay from "../Pages/ConnectDay/ConnectDay.js";
import Home from "../Pages/Home/Home.js";
import Member from "../Pages/Member/Member.js";
import Participant from "../Pages/Participant/Participant.js";
import Thematique from "../Pages/Thematique/Thematique.js";
import ThematiquesDetail from "../Pages/ThematiqueDetail/ThematiquesDetail";

export default function Page({ pages }) {
  const { isEvent } = useCheckEvent();


  return (
    <Switch>
      <Route exact path="/" component={Home} />
      <Route path={["/club", "/club.html"]} component={Club} />
      <Route
        path={["/thematiques", "/thematiques.html"]}
        component={Thematique}
      />
      <Route path="/thematique/:id" component={ThematiquesDetail} />
      <Route path="/member/:name" component={Member} />
      <Route path="/participant/:name" component={Participant} />
      <Route path="/action/:title" component={Action} />
      {isEvent && <Route path="/connect-day" component={ConnectDay} />}
      <Route path="*" component={NotFound} />
    </Switch>
  );
}
